// Máximo 3 decimales, sin ceros sobrantes (evita ver 4.193999999999999 por error de punto flotante).
export const formatStockQuantity = (value) => {
  if (value === null || value === undefined || value === '') return value;
  const rounded = Number(Number(value).toFixed(3));
  return Number.isFinite(rounded) ? String(rounded) : value;
};
